export default "/public/dist/img/banner-2.png";